/* Easy Stride — progressive JS */
(function () {
  'use strict';

  var isThemeEditor = window.Shopify && window.Shopify.designMode;
  if (isThemeEditor) document.documentElement.classList.add('theme-editor');

  // Mobile menu — full-height slide-in panel
  function setMobileMenu(open) {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-nav-toggle]');
    if (!menu) return;
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) { e.preventDefault(); setMobileMenu(true); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); setMobileMenu(false); }
    if (e.target.closest('[data-mobile-menu] a[href]')) { setMobileMenu(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMobileMenu(false); });

  // Testimonial carousel
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quote-target]');
    if (!btn) return;
    var carousel = btn.closest('[data-quote-carousel]');
    if (!carousel) return;
    var target = btn.getAttribute('data-quote-target');
    carousel.querySelectorAll('[data-quote]').forEach(function (q) {
      q.hidden = q.getAttribute('data-quote') !== target;
    });
    carousel.querySelectorAll('[data-quote-target]').forEach(function (b) {
      b.setAttribute('aria-current', b === btn ? 'true' : 'false');
    });
  });

  // Cart drawer open/close
  function setCartDrawer(open) {
    var drawer = document.querySelector('cart-drawer, .cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      setCartDrawer(true);
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      setCartDrawer(false);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setCartDrawer(false);
  });

  // Cart line update / remove — reload page after change. Works in drawer + cart page.
  function updateCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var line = removeBtn.getAttribute('data-cart-line');
      removeBtn.disabled = true;
      removeBtn.setAttribute('aria-busy', 'true');
      updateCartLine(line, 0).then(function () {
        window.location.reload();
      });
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
      var wrap = qtyBtn.closest('[data-qty-wrap]');
      var input = wrap.querySelector('[data-qty-input]');
      var lineId = wrap.getAttribute('data-cart-line');
      var newQty = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = newQty;
      qtyBtn.disabled = true;
      updateCartLine(lineId, newQty).then(function () { window.location.reload(); });
    }
  });

  // AJAX add-to-cart — open the slide-out drawer instead of redirecting to /cart.
  function money(cents) { return '£' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    if (!body) return;
    if (!cart.items || cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p><a href="/collections/all" class="btn btn--secondary btn--full" data-cart-close>Continue browsing</a>';
      return;
    }
    var rows = cart.items.map(function (item, i) {
      var period = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cart-item__plan">' + item.variant_title + ' rental</p>' : '';
      var renew = item.selling_plan_allocation ? '<p class="cart-item__renew"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><polyline points="21 3 21 9 15 9"/></svg><span>Continues at this rate until returned</span></p>' : '';
      var props = '';
      if (item.properties) { for (var k in item.properties) { if (item.properties.hasOwnProperty(k) && k !== 'Rental period' && k.charAt(0) !== '_' && item.properties[k]) { props += '<p class="cart-item__prop">' + k + ': <strong>' + item.properties[k] + '</strong></p>'; } } }
      var img = item.image ? '<img src="' + item.image + '" alt="" width="72" height="72" loading="lazy">' : '';
      return '<li class="cart-item">' + img +
        '<div class="cart-item__body">' +
          '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>' + period + renew + props +
          '<div class="cart-item__row">' +
            '<span class="cart-item__price">' + money(item.final_line_price) + '</span>' +
            '<button type="button" class="cart-item__remove" data-cart-remove data-cart-line="' + (i + 1) + '">Remove</button>' +
          '</div></div></li>';
    }).join('');
    var TH = 30000, ship = '';
    if (cart.total_price >= TH) {
      ship = '<div class="cart-ship-bar cart-ship-bar--done"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg><span>Your rental qualifies for <strong>free UK delivery</strong></span></div>';
    } else {
      var pct = Math.round(cart.total_price * 100 / TH);
      ship = '<div class="cart-ship-bar"><p class="cart-ship-bar__text"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span>You\'re <strong>' + money(TH - cart.total_price) + '</strong> from free UK delivery</span></p><div class="cart-ship-bar__track"><span class="cart-ship-bar__fill" style="width:' + pct + '%"></span></div></div>';
    }
    var disc = '';
    if (cart.total_discount > 0) {
      var titles = [];
      (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.title) titles.push(d.title); });
      (cart.items || []).forEach(function (it) {
        (it.line_level_discount_allocations || []).forEach(function (a) {
          var t = a.discount_application && a.discount_application.title;
          if (t) titles.push(t);
        });
      });
      titles = titles.filter(function (v, i, s) { return s.indexOf(v) === i; });
      disc = '<div class="cart-drawer__line"><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>' +
        '<div class="cart-discounts"><div class="cart-discounts__row">' +
          '<span class="cart-discounts__label"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
          '<span>' + (titles.length ? titles.join(', ') : 'Discount') + ' applied</span></span>' +
          '<span class="cart-discounts__amount">&minus;' + money(cart.total_discount) + '</span>' +
        '</div></div>';
    }
    body.innerHTML = ship + '<ul class="cart-drawer__items">' + rows + '</ul>' +
      '<div class="cart-drawer__totals">' + disc +
        '<div class="cart-drawer__subtotal"><span>' + (cart.total_discount > 0 ? 'Total' : 'Subtotal') + '</span><strong>' + money(cart.total_price) + '</strong></div>' +
        '<a href="/cart" class="btn btn--primary btn--full">Review &amp; checkout</a>' +
        '<p class="cart-drawer__agree-hint">You\'ll confirm the rental terms on the next step.</p></div>';
  }
  function refreshCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        renderCartDrawer(cart);
        if (open) setCartDrawer(true);
      });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshCart(true); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  // Scroll reveal — set up once, and re-observe when theme editor loads sections
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });
  }

  function observeReveals(root) {
    if (!io) return;
    (root || document).querySelectorAll('[data-reveal]:not(.is-inview)').forEach(function (el) {
      io.observe(el);
    });
  }
  observeReveals();

  // Failsafe — if something goes wrong, mark everything visible after 4s.
  setTimeout(function () {
    document.querySelectorAll('[data-reveal]:not(.is-inview)').forEach(function (el) {
      el.classList.add('is-inview');
    });
  }, 4000);

  // Theme editor: re-observe reveals on new/edited sections.
  document.addEventListener('shopify:section:load', function (e) {
    observeReveals(e.target);
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-inview'); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-inview'); });
  });

  // Sticky header scroll state
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    }, { passive: true });
  }

  // Instructions video toggle — switch between "putting on" / "taking off".
  (function () {
    var wrap = document.querySelector('[data-instr]');
    if (!wrap) return;
    var btns = wrap.querySelectorAll('[data-instr-toggle]');
    var vids = wrap.querySelectorAll('[data-instr-video]');
    function activate(target) {
      btns.forEach(function (b) {
        var on = b.getAttribute('data-target') === target;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      vids.forEach(function (clip) {
        var on = clip.getAttribute('data-instr-video') === target;
        clip.classList.toggle('is-active', on);
        var v = clip.querySelector('video');
        if (v && !on) { try { v.pause(); } catch (e) {} }
      });
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-instr-toggle]');
      if (b) activate(b.getAttribute('data-target'));
    });
  })();

  // Delivery date picker — accessible month calendar that writes a line-item property.
  (function () {
    var wrap = document.querySelector('[data-delivery-date]');
    if (!wrap) return;
    var trigger = wrap.querySelector('[data-date-trigger]');
    var display = wrap.querySelector('[data-date-display]');
    var input = wrap.querySelector('[data-date-value]');
    var pop = wrap.querySelector('[data-datepicker]');
    var grid = wrap.querySelector('[data-dp-grid]');
    var monthLabel = wrap.querySelector('[data-dp-month]');
    var prevBtn = wrap.querySelector('[data-dp-prev]');
    var nextBtn = wrap.querySelector('[data-dp-next]');
    var errEl = wrap.querySelector('[data-date-error]');
    var leadDays = parseInt(wrap.getAttribute('data-lead-days'), 10) || 8;
    var blockWeekends = wrap.getAttribute('data-block-weekends') === '1';
    var maxDays = parseInt(wrap.getAttribute('data-max-days'), 10) || 90;
    var required = wrap.getAttribute('data-required') === '1';

    function mid(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
    function isWeekend(d) { var g = d.getDay(); return g === 0 || g === 6; }
    function addWorkingDays(from, n) { var d = new Date(from); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) c++; } return d; }
    function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }); }

    var today = mid(new Date());
    var minDate = mid(addWorkingDays(today, leadDays));
    var maxDate = mid(new Date(today.getTime())); maxDate.setDate(maxDate.getDate() + maxDays);
    var selected = null;
    var view = new Date(minDate.getFullYear(), minDate.getMonth(), 1);

    function disabled(d) { return d < minDate || d > maxDate || (blockWeekends && isWeekend(d)); }
    function render() {
      monthLabel.textContent = view.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
      grid.innerHTML = '';
      var startDow = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7;
      var count = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      for (var i = 0; i < startDow; i++) { var pad = document.createElement('span'); pad.className = 'datepicker__pad'; grid.appendChild(pad); }
      for (var day = 1; day <= count; day++) {
        var d = new Date(view.getFullYear(), view.getMonth(), day);
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'datepicker__day'; b.textContent = day;
        if (disabled(d)) { b.disabled = true; b.className += ' is-disabled'; }
        if (selected && d.getTime() === selected.getTime()) { b.className += ' is-selected'; b.setAttribute('aria-current', 'date'); }
        (function (dd) { b.addEventListener('click', function () { pick(dd); }); })(d);
        grid.appendChild(b);
      }
      prevBtn.disabled = (view.getFullYear() === minDate.getFullYear() && view.getMonth() === minDate.getMonth());
      nextBtn.disabled = (view.getFullYear() === maxDate.getFullYear() && view.getMonth() === maxDate.getMonth());
    }
    function open() { pop.hidden = false; trigger.setAttribute('aria-expanded', 'true'); render(); }
    function close() { pop.hidden = true; trigger.setAttribute('aria-expanded', 'false'); }
    function pick(d) {
      selected = d;
      display.textContent = fmt(d);
      trigger.classList.add('is-set');
      input.name = 'properties[Preferred delivery date]';
      input.value = fmt(d);
      if (errEl) errEl.hidden = true;
      close();
    }
    trigger.addEventListener('click', function () { pop.hidden ? open() : close(); });
    prevBtn.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); });
    nextBtn.addEventListener('click', function () { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target) && !pop.hidden) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    if (required) {
      var form = wrap.closest('form[data-product-form]');
      if (form) form.addEventListener('submit', function (e) {
        if (!selected) { e.preventDefault(); e.stopPropagation(); if (errEl) errEl.hidden = false; open(); }
      }, true);
    }
  })();

  // Social-proof popup — cycles recent-rental notifications, bottom-left.
  (function () {
    var pop = document.querySelector('[data-sales-pop]');
    var dataEl = document.querySelector('[data-sales-data]');
    if (!pop || !dataEl) return;
    var entries;
    try { entries = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!entries.length) return;
    var duration = (parseFloat(pop.getAttribute('data-duration')) || 6) * 1000;
    var gap = (parseFloat(pop.getAttribute('data-gap')) || 12) * 1000;
    var first = (parseFloat(pop.getAttribute('data-first')) || 5) * 1000;
    var productName = pop.getAttribute('data-product-name') || 'Easy Stride';
    var nameEl = pop.querySelector('[data-pop-name]');
    var locEl = pop.querySelector('[data-pop-loc]');
    var actEl = pop.querySelector('[data-pop-action]');
    var timeEl = pop.querySelector('[data-pop-time]');
    var initEl = pop.querySelector('[data-pop-initial]');
    var dismissed = false, order = [], oi = 0;
    function reorder() {
      order = entries.map(function (_, i) { return i; });
      for (var i = order.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = order[i]; order[i] = order[j]; order[j] = t; }
      oi = 0;
    }
    reorder();
    function show() {
      if (dismissed) return;
      if (oi >= order.length) reorder();
      var e = entries[order[oi++]];
      nameEl.textContent = e.name || 'Someone';
      locEl.textContent = e.loc ? 'in ' + e.loc : '';
      actEl.textContent = 'just rented the ' + productName + (e.period ? ' · ' + e.period : '');
      timeEl.textContent = e.time || 'just now';
      initEl.textContent = (e.name || '?').charAt(0).toUpperCase();
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-visible'); });
      setTimeout(hide, duration);
    }
    function hide() {
      pop.classList.remove('is-visible');
      setTimeout(function () { pop.hidden = true; if (!dismissed) setTimeout(show, gap); }, 450);
    }
    var closeBtn = pop.querySelector('[data-sales-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dismissed = true; pop.classList.remove('is-visible'); setTimeout(function () { pop.hidden = true; }, 400); });
    setTimeout(show, first);
  })();

  // Mobile sticky add-to-cart — appears once the main button scrolls out of view.
  var stickyCta = document.querySelector('[data-sticky-cta]');
  var addBtn = document.querySelector('[data-add-btn]');
  if (stickyCta && addBtn && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyCta.classList.toggle('is-visible', scrolledPast);
      });
    }, { threshold: 0 });
    stickyObserver.observe(addBtn);

    var stickyAdd = stickyCta.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.click(); // submit the real form so variant + rental selling plan are preserved
      });
    }
  }

  // Rental-period picker — swap the variant, price, shipping note and sticky price.
  (function () {
    var picker = document.querySelector('[data-duration-picker]');
    if (!picker) return;
    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price-amount]');
    var periodEl = document.querySelector('[data-price-period]');
    var shipEl = document.querySelector('[data-ship-note]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var perdayEl = document.querySelector('[data-perday-note]');
    var planInput = document.querySelector('[data-selling-plan]');
    var rentalProp = document.querySelector('[data-rental-prop]');
    var renewPrice = document.querySelector('[data-renew-price]');
    var renewPeriod = document.querySelector('[data-renew-period]');
    var shipIcon = shipEl ? shipEl.querySelector('svg') : null;
    picker.addEventListener('change', function (e) {
      var input = e.target.closest('[data-variant-option]');
      if (!input) return;
      if (idInput) idInput.value = input.value;
      if (priceEl) priceEl.textContent = input.getAttribute('data-price');
      if (periodEl) periodEl.textContent = '· ' + input.getAttribute('data-period') + ' rental';
      if (shipEl) shipEl.textContent = ' ' + input.getAttribute('data-ship');
      if (shipEl && shipIcon) shipEl.insertBefore(shipIcon, shipEl.firstChild);
      if (stickyPrice) stickyPrice.textContent = input.getAttribute('data-price');
      if (perdayEl) { var pd = input.getAttribute('data-perday'); perdayEl.textContent = pd ? ('Works out at just ' + pd.replace('/day', ' a day')) : ''; }
      // Auto-renewing rental: swap the selling plan + the renewal wording with the period.
      if (planInput) planInput.value = input.getAttribute('data-plan') || '';
      if (rentalProp) rentalProp.value = input.getAttribute('data-period') || '';
      if (renewPrice) renewPrice.textContent = input.getAttribute('data-price');
      if (renewPeriod) renewPeriod.textContent = input.getAttribute('data-period');
      picker.querySelectorAll('.duration-card').forEach(function (card) {
        card.classList.toggle('is-selected', card.contains(input));
      });
    });
  })();

  // Cart rental-terms agreement — gate the checkout button until the box is ticked.
  (function () {
    var wrap = document.querySelector('[data-cart-agree]');
    var form = document.querySelector('[data-cart-form]');
    if (!wrap || !form) return;
    var box = wrap.querySelector('[data-agree-checkbox]');
    var err = wrap.querySelector('[data-agree-error]');
    var btn = form.querySelector('[data-checkout-btn]');
    if (!box) return;
    function sync() { if (btn) btn.disabled = !box.checked; if (box.checked && err) err.hidden = true; }
    sync();
    box.addEventListener('change', function () {
      sync();
      if (box.checked) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Rental terms accepted': 'Yes' } })
        }).catch(function () {});
      }
    });
    form.addEventListener('submit', function (e) {
      if (!box.checked) { e.preventDefault(); if (err) err.hidden = false; box.focus(); }
    });
  })();

  // Video clip crossfade — drives both the hero card and the product-page player.
  document.querySelectorAll('[data-hero-clips]').forEach(function (stage) {
    var clips = [].slice.call(stage.querySelectorAll('[data-hero-clip]'));
    if (!clips.length) return;
    var secs = parseInt(stage.getAttribute('data-clip-seconds'), 10) || 6;
    var i = 0;
    // Clips after the first ship with preload="none" to save bandwidth on first paint.
    // Load the active one on demand, and warm the next so the crossfade stays smooth.
    function prime(v, level, force) {
      if (!v) return;
      if (v.getAttribute('preload') === 'none') {
        v.setAttribute('preload', level);
        if (force) { try { v.load(); } catch (e) {} }
      }
    }
    function show(n) {
      clips.forEach(function (v, idx) {
        var active = idx === n;
        v.classList.toggle('is-active', active);
        if (active) { prime(v, 'auto', false); try { v.currentTime = 0; v.play(); } catch (e) {} }
        else { try { v.pause(); } catch (e) {} }
      });
      prime(clips[(n + 1) % clips.length], 'metadata', true);
    }
    show(0);
    if (clips.length > 1) {
      setInterval(function () { i = (i + 1) % clips.length; show(i); }, secs * 1000);
    }
  });

  // Click-to-load video (instructions section) — keeps the page fast until requested.
  function toVideoEmbed(url) {
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
    if (yt) return { type: 'iframe', src: 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0' };
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return { type: 'iframe', src: 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1' };
    if (/\.mp4($|\?)/i.test(url)) return { type: 'video', src: url };
    return null;
  }
  document.addEventListener('click', function (e) {
    var holder = e.target.closest('[data-video]');
    if (!holder) return;
    var url = holder.getAttribute('data-video-url');
    if (!url) return;
    var embed = toVideoEmbed(url);
    if (!embed) return;
    if (embed.type === 'iframe') {
      holder.innerHTML = '<iframe src="' + embed.src + '" title="Instruction video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
    } else {
      holder.innerHTML = '<video src="' + embed.src + '" controls autoplay playsinline></video>';
    }
  });
})();
